module.exports = __webpack_public_path__ + "img/charging-hub-rejected.c87e292e.png";